module.exports = __webpack_public_path__ + "src/assets/img/girl--dsk.e046b19f.png";